import { 
  createUserWithEmailAndPassword, 
  signInWithEmailAndPassword, 
  signOut,
  GoogleAuthProvider,
  signInWithPopup
} from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { auth, db } from './firebase';

const googleProvider = new GoogleAuthProvider();

/**
 * Registers a new business owner with Email/Password.
 */
export const registerBusiness = async (email: string, password: string, businessName: string) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;
    
    await setDoc(doc(db, 'businesses', user.uid), {
      businessName,
      email,
      createdAt: new Date().toISOString(),
      ownerId: user.uid,
      status: 'active'
    });
    
    return user;
  } catch (error) {
    console.error("Error registering business:", error);
    throw error;
  }
};

/**
 * Signs in an existing business owner with Email/Password.
 */
export const login = async (email: string, password: string) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    return userCredential.user;
  } catch (error) {
    console.error("Error logging in:", error);
    throw error;
  }
};

/**
 * Handles Sign In / Sign Up with Google.
 */
export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, googleProvider);
    const user = result.user;
    
    await setDoc(doc(db, 'businesses', user.uid), {
      businessName: user.displayName ? `${user.displayName}'s Business` : 'My Business',
      email: user.email,
      lastLogin: new Date().toISOString(),
      ownerId: user.uid,
      status: 'active'
    }, { merge: true });

    return user;
  } catch (error) {
    console.error("Error with Google Auth:", error);
    throw error;
  }
};

/**
 * Signs out the current user.
 */
export const logout = async () => {
  try {
    await signOut(auth);
  } catch (error) {
    console.error("Error logging out:", error);
    throw error;
  }
};
